export enum ProjectAdministrationSubpage {
  PRODUCTLISTS = 'productlists',
  REQUESTLISTS = 'requestlists',
  MINLAYERLISTS = 'minlayerlists',
  SOURCELISTS = 'sourcelists',
  TARGETLISTS = 'targetlists',
  FORCEDLISTS = 'forcedlists',
  FORCEDTOZEROLISTS = 'forcedtozerolists',
  YPICK_CREDENTIALS = 'ypick-credentials',
  STORES_SCHEDULE = 'stores-schedule',
  AI_PROMPTS = 'ai-prompts',
  SCOPE = 'scope',
  // ENTITYLISTS = 'entitylists',
}
